import {CounterLabel, UnderlineNav} from '@primer/react'
import {ActionabilityBanner} from './ActionabilityBanner'
import {MergeMethodContextProvider} from '@github-ui/mergebox'
import {CondensedMergeStatusWithSuspense} from '@github-ui/mergebox/components/condensed-mergeability-status'
import {Reviewers} from './Reviewers'
import {SidebarSection} from './SidebarSection'
import {pullRequestsLayoutRoute} from '../../routes/layout-route'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import styles from './Sidebar.module.css'

/** Full Overview sidebar panel */
export function OverviewPanel() {
  const {data: layoutData} = useRouteQuery(pullRequestsLayoutRoute, 'mainQuery')
  const {bannersData, urls, pullRequest, mergeStatusButtonData} = layoutData
  const prStateCanBeActionable = pullRequest.state !== 'CLOSED' && pullRequest.state !== 'MERGED'

  return (
    <div className={styles.sidebar}>
      <UnderlineNav aria-label="Sidebar tabs">
        <UnderlineNav.Item aria-current="page">Info</UnderlineNav.Item>
        <UnderlineNav.Item>
          Comments <CounterLabel>NN</CounterLabel>
        </UnderlineNav.Item>
        <UnderlineNav.Item>
          Findings <CounterLabel>NN</CounterLabel>
        </UnderlineNav.Item>
        <UnderlineNav.Item>Agents</UnderlineNav.Item>
      </UnderlineNav>

      {mergeStatusButtonData && prStateCanBeActionable && (
        <MergeMethodContextProvider defaultMergeMethod={mergeStatusButtonData.defaultMergeMethod}>
          <ActionabilityBanner
            authorLogin={pullRequest.author.login}
            urls={urls}
            headSha={mergeStatusButtonData.headSha}
            channels={mergeStatusButtonData.channels}
            viewerIsRequestedReviewer={bannersData.banners.reviewRequestBanner.render}
          />
          <SidebarSection title="Merge status" actions={['expand']}>
            <CondensedMergeStatusWithSuspense
              headSha={mergeStatusButtonData.headSha}
              channels={mergeStatusButtonData.channels}
            />
          </SidebarSection>
        </MergeMethodContextProvider>
      )}

      <Reviewers />

      <SidebarSection title="Assignees" />
      <SidebarSection title="Labels" />
      <SidebarSection title="Deployments" />
      <SidebarSection title="Projects" />
      <SidebarSection title="Milestone" />
    </div>
  )
}
